import { voiceChatObj } from './voice-chat';

WL.registerComponent('show-speakers', {
  
}, {
  init: function() {
    this.text = this.object.getComponent('text');
    this.speakers = [];
    setInterval(() => {
      for (const player in voiceChatObj.playerVoiceMap) {
        const { name, volume } = voiceChatObj.playerVoiceMap[player]
        if (volume > 20 && !this.speakers.includes(name)) {
          this.speakers.push(name);
        } else if (volume < 20 && this.speakers.includes(name)) {
          this.speakers.splice(this.speakers.indexOf(name), 1);
        } else {
          continue;
        }
      }
      this.text.text = this.speakers.join('\n');
    }, 1000);
  }
});